export default __webpack_public_path__ + "static/media/close.7a6ca12c.svg";